import {PolicyCategoryList} from "./PolicyCategoryList";
import {PolicyCategoryEdit} from "./PolicyCategoryEdit";
import {PolicyCategoryCreate} from "./PolicyCategoryCreate";

export default {
    list: PolicyCategoryList,
    create: PolicyCategoryCreate,
    edit: PolicyCategoryEdit
};
